export default __webpack_public_path__ + "static/media/027-hydrant.934e9810.png";